/** Readiness means a hydrated, usable question control, not just a painted shell. */
export function waitForIntakeControl(
  onReady: () => void,
  scope = "[data-seller-intake]",
): () => void {
  let frame = 0;
  let finished = false;
  const observer = new MutationObserver(check);
  function check() {
    if (finished || frame) return;
    const control = document.querySelector<HTMLElement>(
      ` ${scope} [data-questionnaire-fields] :is(input:not([type=hidden]),textarea,select,button,[role=combobox]):not(:disabled):not([aria-disabled=true]), ${scope} [data-form-ready-control]:not(:disabled):not([aria-disabled=true])`,
    );
    if (!control || control.closest("[hidden],[inert],[aria-hidden=true]"))
      return;
    frame = requestAnimationFrame(() => {
      frame = requestAnimationFrame(() => {
        frame = 0;
        if (
          !control.isConnected ||
          control.matches(":disabled,[aria-disabled=true]")
        ) {
          check();
          return;
        }
        finished = true;
        observer.disconnect();
        onReady();
      });
    });
  }
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: [
      "disabled",
      "aria-disabled",
      "hidden",
      "inert",
      "aria-hidden",
    ],
  });
  check();
  return () => {
    observer.disconnect();
    cancelAnimationFrame(frame);
  };
}
